<div class="page-header">
    <h1 class="text-mayne">{{title}}</h1>
    <p class="sub-header">{{subTitle}}</p>
</div>